export class PhotosModel {
  installationBoxImage: string;
  antennaImage: string;
  schemeImage: string;
  heatingCollectorImage: string;
  postInstallBoilerRoomImages: { image: string }[];
  postInstallHeatingImages: { image: string }[];

  constructor() {
    this.postInstallBoilerRoomImages = [{image: null}, {image: null}, {image: null}];
    this.postInstallHeatingImages = [];
  }

  public static initialize(model: PhotosModel): void {
    if (model.postInstallBoilerRoomImages?.length < 3) {
      model.postInstallBoilerRoomImages = model.postInstallBoilerRoomImages || [];
      while (model.postInstallBoilerRoomImages.length < 3) {
        model.postInstallBoilerRoomImages.push({image: null});
      }
    }

    if (!model.postInstallHeatingImages || model.postInstallHeatingImages.length === 0) {
      model.postInstallHeatingImages = [{image: null}];
    }
  }
}
